var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.999,
    height: 29.999,
    viewBox: "0 0 29.999 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-823.86 -10704.331)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(823.86 10704.331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.999,
    cy: 14.999,
    r: 14.999,
    transform: "translate(0 0)",
    fill: "#1da1f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.9,206.231a3.3,3.3,0,0,0-2.419-1.141,3.348,3.348,0,0,0-2.384,1.03,3.348,3.348,0,0,0-.93,2.425,3.728,3.728,0,0,0,.085.8,9.339,9.339,0,0,1-6.831-3.775,3.666,3.666,0,0,0-.449,1.772,3.647,3.647,0,0,0,1.474,2.961,3.169,3.169,0,0,1-1.5-.458v.045a3.52,3.52,0,0,0,2.659,3.488,3.124,3.124,0,0,1-.873.118,3.131,3.131,0,0,1-.624-.068,3.368,3.368,0,0,0,3.1,2.466,6.4,6.4,0,0,1-4.116,1.5,6.315,6.315,0,0,1-.795-.051,8.942,8.942,0,0,0,5.08,1.59c6.1,0,9.43-5.3,9.43-9.9q0-.227-.01-.451a6.816,6.816,0,0,0,1.653-1.778,6.323,6.323,0,0,1-1.9.521,3.4,3.4,0,0,0,1.458-1.9,6.358,6.358,0,0,1-2.1.815Z",
    transform: "translate(389.423 -197.013)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwIcon);
export default __webpack_public_path__ + "static/media/tw-icon.30c3b99dd58f4864506ebd0b47aea10a.svg";
export { ForwardRef as ReactComponent };